import React from 'react'

import useFlags from '../../hooks/useFlags'
import ActiveFilters from '../filters/ActiveFilters'
import Filters from '../filters/Filters'
import HiddenTherapists from '../HiddenTherapists'
import InsuranceCompanyBanner from '../insuranceCompanies/InsuranceCompanyBanner'
import Loader from '../Loader'
import TherapistCard from '../TherapistCard'
import TherapistCardGrid from '../TherapistCardGrid'
import useFilteredTherapists from './hooks/useFilteredTherapists'

type Props = {
  readonly isPublic?: boolean
}

const TherapistList: React.FC<Props> = ({ isPublic = true }) => {
  const { therapists, hiddenTherapists, isLoadingTimeFilter } = useFilteredTherapists(isPublic)
  const { hideNonVisibleTherapists } = useFlags()

  return (
    <>
      <div className="mb-20 flex w-full flex-col items-center justify-items-center">
        <div className="flex w-full max-w-[1180px] flex-col items-center justify-items-center">
          <Filters />
          {isLoadingTimeFilter ? <Loader visible loaderType="section-large" /> : <ActiveFilters />}
          <InsuranceCompanyBanner />
          <TherapistCardGrid isPublicList={isPublic}>
            {therapists.map((therapist) => (
              <TherapistCard
                therapist={therapist}
                {...therapist}
                key={`${therapist.therapistUserId}-${therapist.therapistId}`}
              />
            ))}
          </TherapistCardGrid>
          {!hideNonVisibleTherapists && isPublic && (
            <div className="mt-20">
              <HiddenTherapists therapists={hiddenTherapists} />
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export default TherapistList
